import { render } from "./HintComponent.vue?vue&type=template&id=2b12f8b9&scoped=true"
import script from "./HintComponent.vue?vue&type=script&lang=js"
export * from "./HintComponent.vue?vue&type=script&lang=js"

import "./HintComponent.vue?vue&type=style&index=0&id=2b12f8b9&scoped=true&lang=css"

import exportComponent from "../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b12f8b9"]])

export default __exports__